import { connect } from 'react-redux'
import { IGlobalState } from '../../../Root/store/appReducer'
import {
  getUserCompanyCountries,
  //getCompanyDivisions,
  joinCompany,
  setUserDivision,
  setUserCountry,
  leaveCompany,
  togglePublicStatus,
  deleteUserOwnedCompany,
} from '../store/SettingsActions'
import { companyCountriesSelector, companyDivisionsSelector, userDtoSelector } from '../store/SettingsSelectors'
import { hasRole, hasRoleInCompany, getUserCompanies, getUserCompanyRoles } from '../../../common/auth/authSelectors'
import { CompanyId, Role } from '../../../services/api.types'
import {
  getCreateTeamLoading,
  getDivisionCategories,
  //getDivisionsSelectorDeprecated,
} from '../../TeamManagement/store/TeamManagementSelectors'
import {
  resetCreateTeamLoading,
  setUserCategoryDivision,
  getDivisionCategories as getDivisionCategoriesAction,
} from '../../TeamManagement/store/TeamManagementActions'
import CompaniesBlock from './CompaniesBlock'

/**
 * Connects the CompaniesBlock component to Redux state
 * Provides data and actions related to companies management
 */
const mapStateToProps = (state: IGlobalState) => ({
  userDto: userDtoSelector(state),
  countries: companyCountriesSelector(state),
  divisions: companyDivisionsSelector(state),
  userCompanies: getUserCompanies(state),
  hasRole: (role: Role) => hasRole(state, role),
  hasRoleInCompany: (companyId: CompanyId, role: Role) => hasRoleInCompany(state, companyId, role),
  userCompanyRoles: getUserCompanyRoles(state),
  createTeamLoading: !!getCreateTeamLoading(state),
  // Division categories and groups data
  divisionCategories: getDivisionCategories(state) || [],
  //companyGroups: getDivisionsSelectorDeprecated(state) || {},
})

/**
 * Provides company-related action creators to the component
 */
const mapDispatchToProps = {
  getUserCompanyCountries,
  //getCompanyDivisions,
  joinCompany,
  leaveCompany,
  deleteUserOwnedCompany,
  setUserDivision,
  setUserCountry,
  togglePublicStatus,
  resetCreateTeamLoading,
  setUserCategoryDivision,
  getDivisionCategories: getDivisionCategoriesAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(CompaniesBlock)
